import React from 'react';

export const ToastrIcon = (data: any): JSX.Element => {
    const {iconSrc} = data;
    return <img src={iconSrc} alt="" />;
};
